<template>
  <div class="quizboard-page" v-show="dataReady">
    <div class="inner">
      <div class="status-image">
        <img :src="gameContent.logo" alt="logo" />
      </div>
      <div class="info-block">
        <h5>Leikreglur</h5>
        <h3>{{isPractice ? 'Æfingasvæðið' : 'Regluvörður' }}</h3>
        <div class="hyphen" v-if="isPractice"></div>
        <p v-html="pageContent.description" :class="{ 'practice': isPractice }">
        </p>
      </div>
    </div>
    <button v-if="this.isLive" type="button" class="button btn-spila" @click="$emit('proceedToQuiz')">Spila</button>
  </div>
</template>

<script>
export default {
  name: 'QuizBoard',
  props: {
    isPractice: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isLive: false,
      count: 0,
      dataReady: false,
      slug: 'quiz-onboarding',
      gameContent: {},
      pageContent: {},
    }
  },
  created() {
    if (this.$data.globalData.webroute === 'live') {
      this.isLive = true
    }
    if (this.$data.globalData.gameContent) {
      this.gameContent = this.$data.globalData.gameContent
    }
    if (this.$data.globalData.pageContent) {
      this.pageContent = this.$data.globalData.pageContent[this.slug]
    }
    this.dataReady = this.pageContent.slug === this.slug
  },
  mounted () {
    this.dataReady = this.pageContent.slug === this.slug
  },
}
</script>

<style lang="scss" scoped>
.quizboard-page {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  padding: 115px 18px 62px;
  overflow-y: auto;
  .inner, button {
    bottom: -10%;
    opacity: 0;
    animation: slideUp 1s forwards;
  }
  .inner {
    position: relative;
    max-width: 500px;
    margin: 0 auto 98px;
    .status-image {
      display: flex;
      img {
        width: 90px;
        height: 90px;
        margin: auto;
      }
    }
    .info-block {
      h5 {
        margin: 0;
        margin-top: 22px;
        font-weight: 400;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
      }
      h3 {
        margin: 0;
        margin-top: 5px;
        line-height: 19px;
        text-align: center;
      }
      .hyphen {
        margin-top: 28px;
        &::before {
          content: "";
          display: flex;
          border: 1px solid #FCBD00;
          width: 19px;
        }
      }
      p {
        margin-top: 16px;
        padding: 20px 20px 10px;
        background: #FFFFFF;
        box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        margin-bottom: 20px;
        text-align: center;
        &:not(.practice) {
          margin-top: 46px;
        }
      }
    }
  }
  .button {
    position: relative;
    max-width: 338px;
    width: 100%;
    margin: 0 auto;
  }
}
@media screen and (max-width: 767px) {
  .quizboard-page {
    height: 100%;
    padding-top: var(--mobile-header-height);
  }
}
</style>
